import Vue from 'vue';
import FontFaceObserver from 'fontfaceobserver';
import { gsap, Power3 } from 'gsap';
import { CustomEase } from '../gsap-bonus/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import imagesLoaded from 'imagesloaded';

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);

Vue.component('panel-slider', {
    props: {
        slides: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            scrollRange: 0,
            activeSlide: 0,
            scrollTriggers: [],
            showTl: [],
            hideTl: []
        };
    },

    mounted() {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if (viewportWidth >= 768) {
            const font = new FontFaceObserver('Merriweather');

            Vue.nextTick(() => {
                font.load(null, 500).then(() => {
                    imagesLoaded(this.$el, () => {
                        gsap.delayedCall(0.2, () => {
                            this.initPanelSlider();
                        });
                    });
                }, () => {
                    imagesLoaded(this.$el, () => {
                        gsap.delayedCall(0.2, () => {
                            this.initPanelSlider();
                        });
                    });
                });
            });
        }

        EventBus.$on('window-resize', () => {
            this.addPanelSliderPadding();
        });

        EventBus.$on('is-mobile-changed', () => {
            if (!this.$root.isMobile) {
                this.initPanelSlider();
            } else if (this.$root.isMobile) {
                if (this.scrollTriggers) {
                    for (let index = 0; index < this.scrollTriggers.length; index++) {
                        this.scrollTriggers[index].kill();
                    }

                    gsap.set(['.panel-slider__visuals-holder-visual', '.panel-slider__slide-title'], { clearProps: 'all' });

                    this.scrollTriggers = [];
                }
            }
        });
    },

    methods: {
        addPanelSliderPadding() {
            const slides = this.$el.querySelectorAll('.panel-slider__slide');
            const visualItem = this.$el.querySelector('.panel-slider__visuals-holder-visual');
            const lastSlide = slides[this.slides.length - 1];
            const lastSlideHeight = lastSlide.getBoundingClientRect().height;

            if (visualItem) {
                const visualHeight = visualItem.getBoundingClientRect().height;
                if (this.slides[this.slides.length - 1].image && visualHeight > lastSlideHeight) {
                    this.$refs.panelslider.classList.add('panel-slider--padding-bottom');
                }
            }
        },

        initPanelSlider() {
            this.addPanelSliderPadding();

            const slides = this.$el.querySelectorAll('.panel-slider__slide');

            for (let index = 0; index < this.slides.length; index++) {
                const currentElement = slides[index];
                const scrollRange = slides[index].getBoundingClientRect().height;
                const title = currentElement.querySelector('.panel-slider__slide-title');
                const visual = currentElement.querySelector('.panel-slider__visuals-holder-visual');

                CustomEase.create("generalEase", "0.45, 0, 0.33, 1");
                CustomEase.create("expoEase", "0.82, 0, 0.36, 1");

                this.showTl[index] = gsap.timeline({
                    paused: true,
                });

                this.showTl[index].to(title, { y: 0, duration: 0.7, autoAlpha: 1, ease: 'generalEase' }, 0);
                if (visual) {
                    this.showTl[index].to(visual, { y: 0, duration: 1, autoAlpha: 1, ease: 'generalEase' }, 0.05);

                }

                this.hideTl[index] = gsap.timeline({
                    paused: true,
                });

                this.hideTl[index].to(title, { duration: 0.5, autoAlpha: 0, ease: 'expoEase' }, 0.05);
                if (visual) {
                    this.hideTl[index].to(visual, { duration: 0.42, autoAlpha: 0, ease: 'expoEase' }, 0.1);
                }

                this.scrollTriggers[index] = ScrollTrigger.create({
                    trigger: currentElement,
                    start: 'top 65%',
                    end: '+=' + scrollRange + 'px',
                    onEnter: () => {
                        if (index > 0) {
                            currentElement.classList.add('panel-slider__slide--active');
                            gsap.set([currentElement.querySelector('.panel-slider__slide-title'), currentElement.querySelector('.panel-slider__visuals-holder-visual')], { autoAlpha: 0, y: 30 });
                            this.hideTl[index].kill();
                            this.showTl[index].play(0);
                        }
                    },
                    onLeave: () => {
                        if (index != this.slides.length - 1) {
                            currentElement.classList.remove('panel-slider__slide--active');
                            this.showTl[index].kill();
                            this.hideTl[index].play(0);
                        }
                    },
                    onEnterBack: () => {
                        if (index != this.slides.length - 1) {
                            currentElement.classList.add('panel-slider__slide--active');
                            gsap.set([currentElement.querySelector('.panel-slider__slide-title'), currentElement.querySelector('.panel-slider__visuals-holder-visual')], { autoAlpha: 0, y: 30 });
                            this.hideTl[index].kill();
                            this.showTl[index].play(0);
                        }
                    },
                    onLeaveBack: () => {
                        if (index > 0) {
                            currentElement.classList.remove('panel-slider__slide--active');
                            this.showTl[index].kill();
                            this.hideTl[index].play(0);
                        }
                    },
                });
            }
        },
    },
});
